import { ComponentFields, Field, ImageField, Item, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { LearningTypes } from 'src/enums/LearningTypes';

import { ContentDetailItem } from 'src/types/ContentDetailsItem';
import { ExtendedItem } from 'src/types/ExtendedItem';
import { ResourceListItem } from 'src/types/ResourceListItem';

import { parseAccessLevelRouteFields } from '../fields/parseAccessLevelContent';
import { parseAccessTypes, parseAccessTypesString } from '../fields/parseAccessTypes';
import { parseIsoDate } from '../fields/parseDate';
import { parseLearningFormats } from '../fields/parseLearningFormats';
import { parseTags } from '../fields/parseTags';
import { parseTypesOfResources, parseTypesOfResourcesString } from '../fields/parseTypesOfResources';

export function mapLMSCourse(item: ExtendedItem): ResourceListItem | null {
	try {
		if (!item) {
			return null;
		}

		// TODO Cost as its on the cohort item under the course
		// const costItem = (item.fields.Costs as Item[])?.find(
		// 	(c) => c && (c.fields?.Cost as Field<string>)?.value
		// );
		// let cost = (costItem?.fields?.Cost as Field<string>)?.value;
		// if ((costItem?.fields?.PlusVat as Field<string>)?.value) {
		// 	cost += ' ' + (costItem?.fields?.PlusVatText as Field<string>).value;
		// }

		return {
			Id: item.id,
			Title: (item.fields.PageTitle as Field<string>).value,
			Strapline: (item.fields.Strapline as Field<string>)?.value,
			ImageUrl: item.fields.PageImage ? (item.fields.PageImage as ImageField)?.value?.src : '',
			Cost: undefined,
			LearningFormats: parseLearningFormats(item.fields.LearningFormat),
			TypesOfResources: parseTypesOfResources(item.fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(item.fields.Tags),
			Url: item.url,
			LearningType: LearningTypes.Course.toString(),
			AccessTypes: parseAccessTypes(item.fields.AccessType),
			AccessTypesString: parseAccessTypesString(item.fields.AccessType),
			Tags: parseTags(item.fields.Tags),
			Location: (item.fields.Location as Field<string>)?.value,
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}

export function mapLMSCourseToContentDetails(id: string, fields: ComponentFields | undefined): ContentDetailItem | null {
	try {
		if (!fields) {
			return null;
		}

		const dateUpdated = fields.DateUpdated ? parseIsoDate((fields.DateUpdated as Field<string>).value) : null;
		// TODO Date as its on the cohort item under the course
		// const date = fields['Start Date'] ? parseIsoDate((fields['Start Date'] as Field<string>).value) : null;
		// const endDate = fields['End Date'] ? parseIsoDate((fields['End Date'] as Field<string>).value) : null;

		const professionalLeadItem = fields['Professional Lead'] as Item;

		// TODO Cost as its on the cohort item under the course
		// const costItem = (fields.Costs as Item[])?.find((c) => c && (c.fields?.Cost as Field<string>)?.value);
		// let cost = (costItem?.fields?.Cost as Field<string>)?.value;
		// if ((costItem?.fields?.PlusVat as Field<string>)?.value) {
		// 	cost += ' ' + (costItem?.fields?.PlusVatText as Field<string>)?.value;
		// }

		return {
			Id: id,
			Title: (fields.PageTitle as Field<string>).value,
			Strapline: (fields.Strapline as Field<string>)?.value,
			ImageUrl: fields.PageImage ? (fields.PageImage as ImageField).value?.src : '',
			Tags: parseTags(fields.Tags),
			AccessTypes: parseAccessTypes(fields.AccessType),
			AccessTypesString: parseAccessTypesString(fields.AccessType),
			Access: parseAccessLevelRouteFields(fields),
			TypesOfResources: parseTypesOfResources(fields.Tags),
			TypesOfResourcesString: parseTypesOfResourcesString(fields.Tags),
			DateUpdated: dateUpdated,
			Information: '',
			IsCpdArticle: false,
			IsLmsModule: false,
			IsLmsCourse: true,
			IsResource: false,
			Cost: undefined,
			Date: undefined,
			EndDate: undefined,
			LearningFormats: parseLearningFormats(fields.LearningFormat),
			CPDHours: (fields.CPDHours as Field<string>)?.value,
			CertificateOfCompletion: fields.CertificateOfCompletion && (fields.CertificateOfCompletion as Field<boolean>).value === true,
			ProfessionalLeads: professionalLeadItem
				? {
						FirstName: professionalLeadItem.fields['First name']
							? (professionalLeadItem.fields['First name'] as Field<string>)?.value
							: undefined,
						LastName: professionalLeadItem.fields['Last name']
							? (professionalLeadItem.fields['Last name'] as Field<string>)?.value
							: undefined,
						Email: professionalLeadItem.fields['Email Address']
							? (professionalLeadItem.fields['Email Address'] as Field<string>)?.value
							: undefined,
				  }
				: undefined,
			ResourceSponsor: '',
			PeerReviewed: fields.PeerReviewed && (fields.PeerReviewed as Field<boolean>).value === true,
			LearningTypeString: LearningTypes.Course.toString(),
			LearningType: LearningTypes.Course,
			Location: (fields.Location as Field<string>)?.value,
			Url: (fields.CourseLink as LinkField)?.value?.href,
			UserCanSelfEnrol: (fields.UserCanSelfEnrol as Field<boolean>)?.value === true,
			EnrolDisclaimerText: (fields.EnrolDisclaimerText as Field<string>)?.value,
		};
	} catch (error) {
		console.error(error);
		return null;
	}
}
